// extracted by mini-css-extract-plugin
export default {"group":"c94UAa","tags":"st2nU_","link":"DYMnqx"};